import { type ComponentProps } from "react";

import { SelectableOption } from "~/components/ui/selectable-option";

export type QuestionChoiceProps = ComponentProps<typeof SelectableOption>;

/** A selectable option composed specifically for questionnaire answers. */
export function QuestionChoice(props: QuestionChoiceProps) {
  return <SelectableOption {...props} />;
}

export {
  selectableOptionVariants as questionChoiceVariants,
} from "~/components/ui/selectable-option";
